module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.allowedDomain) ? _c('v-app', [_c('welcome-message', {
    staticClass: "welcome-message-header",
    class: {
      'show': _vm.showWelcome
    }
  }), _vm._v(" "), _c('router-view', {
    ref: "view"
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef52ddc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 421
// module chunks = 2